module.exports = __webpack_public_path__ + "static/media/wooden_shield.f966304c.png";